export interface LabelPhotoUpload {
  barcode: string;
  frameJpeg: string;
}

/** Logged-in scans with a frozen frame can upload. The barcode stays the decoder text. */
export function labelPhotoUpload(
  loggedIn: boolean,
  code: string,
  frameJpeg: string | null
): LabelPhotoUpload | null {
  if (!loggedIn || !frameJpeg) return null;
  return { barcode: code, frameJpeg };
}

export function jpegDataUrlToBlob(dataUrl: string): Blob {
  const comma = dataUrl.indexOf(',');
  if (comma < 0 || !dataUrl.startsWith('data:image/jpeg')) {
    throw new Error('expected a jpeg data url');
  }

  const binary = atob(dataUrl.slice(comma + 1));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: 'image/jpeg' });
}
